export function pluralize(count: number, word: string, ending: 's' | 'es' = 's') {
  return count === 1 ? word : `${word}${ending}`
}
